var accordions = document.querySelectorAll('[data-faq-block]');
for (let i = 0; i < accordions.length; i++) {
    accordions[i].addEventListener('click', function(){
        accordions[i].classList.toggle('active');
    })
}

if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
    if (document.querySelectorAll('.section-accordion-faq__links').length > 0) {
      document.querySelector('.section-accordion-faq__links').addEventListener('click', function(){
        this.classList.toggle('active');
      })
      document.querySelectorAll('.faq__link-container').forEach(function(elem){
        elem.addEventListener('click', function(){
          var alreadyActive = document.querySelectorAll('.faq__link-container.active');
          for (var x = 0; x < alreadyActive.length; x++) {
            alreadyActive[x].classList.remove('active');
          }
          elem.classList.add('active');
        })
      })
    }
  }